import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { Text1, Text4, Text5 } from '../../../styles';
import { bulkFieldsMaster, bulkErrorColumns, webhookErrorColumns } from './constants';
import { EaseTable } from '../../../libs/EaseTable';


const ErrorModal = (props) => {
    const errors = props.errors || [];

    const prepDataForTable = (records_error) => {
        let data = [];
        Object.keys(records_error.missing_fields).forEach(field =>
            data.push({
                "field": bulkFieldsMaster[field] ? bulkFieldsMaster[field] : field,
                "category": "Missing Value",
                "row_numbers": records_error.missing_fields[field].row_numbers.toString(),
                "message": records_error.missing_fields[field].message
            })
        );
        Object.keys(records_error.invalid_data).forEach(field =>
            data.push({
                "field": bulkFieldsMaster[field] ? bulkFieldsMaster[field] : field,
                "category": "Invalid Data",
                "row_numbers": records_error.invalid_data[field].row_numbers.toString(),
                "message": records_error.invalid_data[field].message
            })
        );
        return data;
    };

    const prepWebhookDataForTable = (records_error) => {
        let data = [];
        Object.keys(records_error).forEach(field => {
            if (field != 'type') {
                if (records_error[field].missing_value){
                    Object.keys(records_error[field].missing_value).forEach(sub_field =>{
                        data.push({
                            "label": records_error[field].event_label,
                            "field": bulkFieldsMaster[sub_field] ? bulkFieldsMaster[sub_field] : sub_field,
                            "category": "Missing Value",
                            "message": records_error[field].missing_value[sub_field].message
                        })
                    })
                }
                if (records_error[field].invalid_data){
                    Object.keys(records_error[field].invalid_data).forEach(sub_field =>{
                        data.push({
                            "label": records_error[field].event_label,
                            "field": bulkFieldsMaster[sub_field] ? bulkFieldsMaster[sub_field] : sub_field,
                            "category": "Invalid Data",
                            "message": records_error[field].invalid_data[sub_field].message
                        })
                    })
                }
            }
            
        });
        return data;
    };

    const renderFileErrors = () => {
        const file_error = errors.find(error => error.type == "FILE");
        if (!file_error) return null;
        return (
            <div className="mt-2">
                <Text4 strong>File Error:</Text4>
                <Text4 className="ml-1">{file_error.message}</Text4>
            </div>
        )
    };

    const renderSheetErrors = () => {
        const sheet_error = errors.find(error => error.type == "SHEET");
        if (!sheet_error) return null;
        return (
            <div className="mt-2">
                <Text4 strong>Sheet Error:</Text4>
                <Text4 className="ml-1">{sheet_error.message}</Text4>
            </div>
        )
    };

    const renderAccountErrors = () => {
        const account_error = errors.find(error => error.type == "ACCOUNT");
        if (!account_error) return null;
        return (
            <div className="mt-2">
                <Text4 strong>Account Error:</Text4>
                <Text4 className="ml-1">{account_error.message}</Text4>
            </div>
        )
    }

    const renderRecordErrors = () => {
        const records_error = errors.find(error => error.type == "RECORDS");
        if (!records_error) return null;
        const tableData = prepDataForTable(records_error);
        return (
            <div className="mt-2">
                <Text4 strong>Records Error:</Text4>
                <EaseTable
                    size="small"
                    data={tableData}
                    columns={bulkErrorColumns}
                />
            </div>
        )
    };

    const renderWebhookErrors = () => {
        const records_error = errors.find(error => error.type == "WEBHOOK");
        if (!records_error) return null;
        const tableData = prepWebhookDataForTable(records_error);
        return (
            <div className="mt-2">
                <Text4 strong>Webhook Error:</Text4>
                <EaseTable
                    size="small"
                    data={tableData}
                    columns={webhookErrorColumns}
                />
            </div>
        )
    };

    return (
        <EaseModal
            width={650}
            title={false}
            visible={props.visible}
            onCancel={props.toggleErrorModal}
            centered
            hideFooter
            destroyOnClose
        >
            <Text1 className="d-block" type="danger" strong>Failure</Text1>
            <Text5 className="d-block mt-1 mb-4" type="secondary">{props.alert_message}:</Text5>
            {renderFileErrors()}
            {renderSheetErrors()}
            {renderAccountErrors()}
            {renderRecordErrors()}
            {renderWebhookErrors()}
        </EaseModal>
    )
};

ErrorModal.defaultProps = {
    alert_message: 'Consult the following errors, fix your file and upload again.',
}


export { ErrorModal };